import {
    WidgetStrategyWithConfig,
    WidgetStrategyWithStreams,
} from 'widgets/WidgetRegistry';
import { OrderColumns } from 'communication/types/order/Order';
import { WidgetCategory } from 'widgets/WidgetCategory';
import PortfolioPl from 'widgets/portfolioPl/PortfolioPl';
import { portfolioPlDescription } from 'widgets/portfolioPl/description/portfolioPlDescription';
import { buildPortfolioPlConfigSlice } from 'widgets/portfolioPl/store/config/configSlice';
import { PortfolioPlWidgetConfigState } from 'widgets/portfolioPl/store/config/PortfolioPlWidgetConfigState';
import { PortfolioSelectionRequirements } from 'widgets/PortfolioSelectionRequirements';
import { streamConfig } from 'widgets/portfolioPl/store/stream/stream-config';
import { AppMode } from 'app/store/general/AppMode';

const { initialConfigState } = buildPortfolioPlConfigSlice();

export const portfolioPlWidgetStrategy: WidgetStrategyWithConfig<PortfolioPlWidgetConfigState> &
    WidgetStrategyWithStreams = {
    title: 'Profit & Loss',
    supportedHosts: ['layout'],
    reactComponentType: PortfolioPl,
    initialConfigState,
    getRequiredOrderColumns,
    categories: [
        {
            appModes: [AppMode.STANDALONE],
            categories: [WidgetCategory.MULTIPLE_STOCK],
        },
        {
            appModes: [AppMode.EMBEDDED_DASHBOARD],
            categories: [WidgetCategory.PORTFOLIO],
        },
    ],
    description: portfolioPlDescription,
    streamConfigs: [streamConfig],
    portfolioSelectionRequirements:
        PortfolioSelectionRequirements.AtLeastOneOrder,
};

function getRequiredOrderColumns(): OrderColumns {
    return ['qty', 'fillQty', 'avgPx'];
}
